import React from 'react';
import { FiFrown } from 'react-icons/fi';

import { Box, Container, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';

import PageTitle from '../../components/PageTitle';

const errorStyles = makeStyles({
  boxText: {
    maxWidth: '442px',
    margin: '24px auto 40px auto',
    '& p': {
      fontSize: '16px',
    },
  },
  boxIcon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
});

export default function NotFound() {
  const classes = errorStyles();

  return (
    <Box mt={5} mb={8}>
      <Container>
        <PageTitle title="Central de Montagem" />
        <Box className={classes.boxIcon}>
          <FiFrown size={90} />
        </Box>
        <Box mt={5} mb={3} textAlign="center">
          <Typography component="div">
            <Box fontSize={40} fontWeight="bold" mb={3} lineHeight={1.2}>
              Oooops, não encontramos essa página
            </Box>
          </Typography>
          <Box className={classes.boxText}>
            <Typography>
              Confira se você digitou direitinho o endereço que queria. Se
              estiver tudo certo, pode ser que o conteúdo tenha sido removido.
            </Typography>
          </Box>
        </Box>
      </Container>
    </Box>
  );
}
